<div class="container d-flex direction-column align-center mt-2 mb-2">
  <div class="container-content content d-flex align-center justify-space-between">
    <div class="content-card card d-flex align-center justify-space-around"
         [ngClass]="{
        'transfer-manual': isManual,
        'card-delete': contract.IsDelete
      }">
      <span *ngIf="contract.Error"
            class="card-error"
            [matTooltip]="contract.MsgError?.replace('WARNING:', '') || ''">
        <app-svg-icon class=""
                      src="assets/icons/warning-icon.svg"
                      alt="expand"
                      width="22px"
                      [color]="contract.MsgError?.startsWith('WARNING') ? 'warn' : 'dangerRed'"
                      [attr.color]="contract.MsgError?.startsWith('WARNING') ? 'warn' : 'dangerRed'"></app-svg-icon>
      </span>

      <ng-content select="[checkbox]"></ng-content>

      <div class="card-icon align-center mr-20">
        <app-svg-icon src="../../../../assets/icons/status-repasse.svg"
                      color=""
                      [ativo]="contract.Active"
                      width="18px"
                      height="20px"
                      class="ml-20">
        </app-svg-icon>
      </div>

      <div class="card-data data flex-1" [matTooltip]="contract.Number + ((contract.Version || contract.Version === 0 ? ' (v. '+ contract.Version +')' : ''))">
        <span class="data-bank bank">{{ contract.Number + ((contract.Version || contract.Version === 0 ? ' (v. '+ contract.Version +')' : '')) | titlecase}}</span>
      </div>

      <div class="card-data data flex-1" [matTooltip]="contract.QueryNumber || ''">
        <span class="data-bank bank">{{ contract.QueryNumber | titlecase}}</span>
      </div>

      <div class="card-data data flex-1"
           [matTooltip]="contract.FinancialInstitution || ''">
        <span class="data-bank bank">
          {{
          contract.FinancialInstitution || "-" | titlecase
          }}
        </span>
      </div>

      <div class="card-data data flex-1">
        <span class="data-generic generic">
          {{
          contract.Amount ? (contract.Amount | currency : "BRL") : "-"
          }}
        </span>
      </div>

      <div class="card-data data flex-1"
           *ngIf="typeDetail === DetailLotEnum.Invoicing">
        <span class="data-generic generic">
          {{
          (contract.InvoiceAmount | currency : "BRL") || "-"
          }}
        </span>
        <!--Descomentar para resolver erro no console.-->
        <!--<span class="data-generic generic">{{
            contract && contract.InvoiceAmount ?
              (contract.InvoiceAmount.toString().replace(',', '.') | currency : 'BRL') :
              '-'
        }}</span>-->
      </div>

      <div class="card-data data flex-1"
           *ngIf="typeDetail === DetailLotEnum.Transfer">
        <span class="data-generic generic">
          {{
          contract.TransferAmountNegativo ?
          (contract.TransferAmountNegativo | currency : "BRL"):
          (contract.TransferAmount | currency : "BRL") || "-"
          }}
        </span>
      </div>

      <div class="card-data data flex-1" *ngIf="!isModal">
        <span class="data-generic generic">
          {{
          contract.OperationType || "-"
          }}
        </span>
      </div>

      <div class="card-data data flex-1" [matTooltip]="contract.Client || ''">
        <span class="data-generic generic">{{ contract.Client || "-" }}</span>
      </div>

      <div class="card-data data flex-1"
           [matTooltip]="contract.ClientDocument || ''">
        <span class="data-generic generic">
          {{
          contract.ClientDocument || "-"
          }}
        </span>
      </div>

      <div class="card-data data flex-1"
           *ngIf="typeDetail === DetailLotEnum.Invoicing">
        <span class="data-fee fee">{{ (contract.ProductName === 'Repasse') ? (contract.BeneficiaryFee | currency : "BRL") : (contract.BeneficiaryFee + '%')}}</span>
      </div>

      <div class="card-data data flex-1"
           *ngIf="typeDetail === DetailLotEnum.Transfer">
        <span class="data-generic generic">{{ contract.Chanel || "-" }}</span>
      </div>

      <div class="card-data data flex-1" *ngIf="!isModal">
        <span class="data-generic generic">
          {{
          (contract.ProductionDate | date : "dd/MM/yyyy") || "-"
          }}
        </span>
      </div>

      <div class="card-data data flex-1"
           *ngIf="isManual"
           [matTooltip]="contract.InvoiceBatchNumber || ''">
        <span class="data-generic generic">
          {{
          contract.InvoiceBatchNumber || "-"
          }}
        </span>
      </div>

      <div class="card-data data flex-1" [matTooltip]="contract.StatusOverride || contract.Status">
        <app-status-badge
          [label]="contract.StatusOverride || contract.Status || '-'"
          [tone]="statusTone"
          variant="outline"
          size="sm">
        </app-status-badge>
      </div>
    </div>

    <div class="content-btn btn d-flex" [ngClass]="{ 'btn-manual': isManual }">
      <button class="btn-view d-flex align-center justify-center"
              (click)="openModalDetails(contract.Number)">
        <app-svg-icon src="assets/icons/view-icon.svg"
                      width="16px"
                      height="16px"
                      color="white"></app-svg-icon>
      </button>

      <ng-content select="[delete]"></ng-content>
    </div>
  </div>
</div>
